module.exports = __webpack_public_path__ + "img/success-launch.8ab41d5f.svg";